import { ReactNode, useEffect, useRef } from "react";
import styles from "./success-animation.module.css";
import { getPathPrefix } from "utils/getPathPrefix";

interface SuccessAnimationProps {
  children: ReactNode;
  showSuccess: boolean;
  successImage: "yeah" | "hopa";
  onComplete: () => void;
}

export default function SuccessAnimation({ children, showSuccess, successImage, onComplete }: SuccessAnimationProps) {
  const imagePath = getPathPrefix(`/images/onboarding/cim/${successImage}.png`);
  const hasTriggeredRef = useRef(false);

  useEffect(() => {
    if (showSuccess && !hasTriggeredRef.current) {
      hasTriggeredRef.current = true;

      const timer = setTimeout(() => {
        onComplete();
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  return (
    <div className={styles.container}>
      {children}
      <img src={imagePath} alt="Success" className={`${styles.successImage} ${showSuccess ? styles.show : ""}`} />
    </div>
  );
}
